export const SHOPPABLE_WIDGET_OPTIONS_DEFAULTS = {
  location: 'right',
  toggleIcon: '',
  width: '20%',
  startState: 'openOnPlay',
  autoClose: 2,
  transformation: {
    quality: 'auto',
    width: 'auto',
    fetch_format: 'auto',
    crop: 'scale'
  },
  products: [],
  showPostPlayOverlay: false
};

export const SHOPPABLE_CLICK_ACTIONS = {
  GO_TO: 'goto',
  SEEk: 'seek'
};

export const SHOPPABLE_HOVER_ACTIONS = {
  OVERLAY: 'overlay'
};

export const SHOPPABLE_PANEL_VISIBLE_CLASS = 'shoppable-panel-visible';

export const SHOPPABLE_PANEL_HIDDEN_CLASS = 'shoppable-panel-hidden';

export const SHOPPABLE_PRODUCTS_OVERLAY_CLASS = 'shoppable-products-overlay';

export const CLD_SPBL_PANEL_CLASS = 'cld-spbl-panel';

export const CLD_SPBL_TOGGLE_CLASS = 'cld-spbl-toggle';

export const CLD_SPBL_TOGGLE_ICON_CLASS = 'cld-spbl-toggle-icon';

export const CLD_SPBL_INNER_BAR = 'cld-spbl-bar-inner';

export const CLD_SPBL_TOGGLE_CUSTOM_ICON_CLASS = 'cld-spbl-toggle-custom-icon';

export const ICON_CART_CLASS = 'vjs-icon-cart';

export const CLOSE_ICON_CLASS = 'vjs-icon-close';

export const SHOPPABLE_ANIMATION_CLASS = 'animate';

export const CLD_SPBL_ITEM = 'cld-spbl-item';

export const CLD_SPBL_IMAGE = 'cld-spbl-img';
